export const checkAboutUsPageEnabled = () =>
  parseInt(process.env.REACT_APP_ABOUT_US_PAGE_ENABLED ?? "0") > 0;
